<template>
    <div class="d-flex justify-space-between align-center px-4 mb-4">
        <v-btn
            :disabled="page === 1"
            @click="$emit('back')"
            class="pa-1"
            prepend-icon="mdi-arrow-left"
            variant="text"
        >
            {{ translate('common.back') }}
        </v-btn>
        <div class="text-caption medium text-medium-emphasis">{{ page }}/2</div>
    </div>
</template>

<script>
import { locales_mixin } from '@old/mixins/locales_mixin'

export default {
    name: 'AmortizationBackToolbar',
    props: {
        page: {
            type: Number,
        },
    },
    mixins: [locales_mixin],
    components: {},
    emits: ['back'],
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {},
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
